// Native & external imports
import { NgModule } from '@angular/core';
import { CommonModule, TitleCasePipe, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule  } from '@angular/router';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { NgOrderByPipeModule } from '../pipes/order-by.pipe';
import { CmpSharedModule } from 'icamppro-shared-components';
import { InactivityModalComponent } from './timeout-modals/inactivity-modal/inactivity-modal.component';
import { LottieComponent, provideLottieOptions } from 'ngx-lottie';
import player from "lottie-web";
import { NoticeboxPersistComponent } from './noticebox-persist/noticebox-persist.component';
import { PersistAlertService } from '../services/persist-alert.service';

function playerFactory() {
  return player;
}

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    CmpSharedModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    NgOrderByPipeModule,
    LottieComponent,
  ],
  declarations: [
    InactivityModalComponent,
    NoticeboxPersistComponent,
  ],
  providers: [
    DatePipe,
    TitleCasePipe,
    PersistAlertService,
    provideLottieOptions({ player: playerFactory }),
  ],
  exports: [
	InactivityModalComponent,
    NoticeboxPersistComponent,
  ]
})
export class CmpSharedComponentsModule { }
